"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Observable_1 = require("rxjs/Observable");
var takeWhileInclusive_1 = require("../../operator/takeWhileInclusive");
Observable_1.Observable.prototype.takeWhileInclusive = takeWhileInclusive_1.takeWhileInclusive;
//# sourceMappingURL=takeWhileInclusive.js.map


//////////////////
// WEBPACK FOOTER
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/~/rxjs-extra/add/operator/takeWhileInclusive.js
// module id = ../../../../rxjs-extra/add/operator/takeWhileInclusive.js
// module chunks = 5